export const getUserIp = async (): Promise<string | null> => {
  try {
    const res = await fetch('https://api64.ipify.org?format=json');
    const data = await res.json();

    return data?.ip || null;
  } catch {
    // silent catch
    return null;
  }
};
